export default "__VITE_ASSET__38a53003__"